function getEmptyCategoryContent() {
    let $emptyContent = $('.empty-content.empty-content-category');

    if (!$emptyContent.length) {
        $emptyContent = $('.category-content-wrapper .empty-content');
    }

    if (!$emptyContent.length) {
        $emptyContent = $('.category-content-wrapper').find('h2').filter(function () {
            return $(this).text().trim().indexOf('Produkty teprve připravujeme') !== -1;
        }).closest('div');
    }

    if (!$emptyContent.length) {
        $emptyContent = $('h2').filter(function () {
            return $(this).text().trim().indexOf('Produkty teprve připravujeme') !== -1;
        }).closest('div');
    }

    return $emptyContent;
}

function isPriceFilterActive() {
    const currentParams = new URLSearchParams(window.location.search);

    if (currentParams.has('priceMin') || currentParams.has('priceMax')) {
        return true;
    }

    let referer = $('#price-filter-form input[name="referer"]').val();

    if (!referer) {
        referer = $('#filters input[name="referer"]').first().val();
    }

    if (!referer) {
        return false;
    }

    referer = $('<textarea/>').html(referer).text();

    const queryString = referer.indexOf('?') !== -1
        ? referer.split('?')[1]
        : '';

    if (!queryString) {
        return false;
    }

    const refererParams = new URLSearchParams(queryString);

    return refererParams.has('priceMin') || refererParams.has('priceMax');
}

function checkFiltersEmptyState() {
    const $emptyContent = getEmptyCategoryContent();

    const hasEmptyProducts = $emptyContent.length > 0;
    const hasActiveCheckboxFilter = $('#filters input[type="checkbox"]:checked').length > 0;
    const hasActiveLabelFilter = $('#filters label.filter-label.active').length > 0;
    const hasActivePriceFilter = isPriceFilterActive();
   /* console.log({
    empty: $emptyContent.length,
    checked: $('#filters input[type="checkbox"]:checked').length,
    activeLabel: $('#filters label.filter-label.active').length,
    price: hasActivePriceFilter,
    emptyElement: $emptyContent.get(0)
});*/
    if (hasEmptyProducts && (hasActiveCheckboxFilter || hasActiveLabelFilter || hasActivePriceFilter)) {
        $emptyContent
            .addClass('noFilters')
            .html(disableFiltreConbination);
    }
}

function runCheckFiltersEmptyState() {
    checkFiltersEmptyState();

    setTimeout(checkFiltersEmptyState, 300);
    setTimeout(checkFiltersEmptyState, 800);
    setTimeout(checkFiltersEmptyState, 1500);
}

$(function () {
    runCheckFiltersEmptyState();
});

$(document).on(
    'ShoptetDOMContentLoaded ShoptetDOMPageContentLoaded ShoptetPageSortingChanged ShoptetDOMPageMoreProductsLoaded',
    function () {
        runCheckFiltersEmptyState();
    }
);

$(document).on('click', '.resetFiltersBtn', function (e) {
    e.preventDefault();

    window.location.href = window.location.pathname;
});